module.exports = __webpack_public_path__ + "Roboto-LightItalic.cdd1c486770034a6122e.eot";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-LightItalic.eot
// module chunks = styles